import * as React from "react";
import Loader from "react-loader";
import { Redirect } from "react-router-dom";
import Sidenav, {
  Toggle,
  Nav,
  NavItem,
  NavIcon,
  NavText,
} from "@trendmicro/react-sidenav";
import { CSSTransition } from "react-transition-group";
import Modal from "react-awesome-modal";
import ClickOutside from "react-click-outside";
import { toast, ToastContainer } from "react-toastify";
// services
import {
  currentBaseUrl,
  currentUser,
  getGeneralSmartTableData,
  getUserAge,
  isUserLoggedIn,
} from "../../../../common/services";

import NavBar from "../../../../components/CustomNav/CustomNav.Component";
import ResponsesTile from "../../../../common/responsesTile.Component";
import TraitTile from "../../../../common/traitTile.Component";
import PerceptionsTile from "../../../../common/perceptionsTileNew.Component";
import PerceptionScatterGraph from "../../../../common/DataViz/studentPerceptionGraph.Component";
import SingleResponseChart from "../../../../common/singleResponseChart.Component";
import BarGraph from "../../../../components/DataViz/BarGraph/BarGraph";
import SimpleLoader from "../../../../components/SimpleLoader/SimpleLoader.Component";
import { Loader as Loaderr } from "../../../../components/SimpleLoader/SimpleLoader.styles";
import { FabButton } from "../../../Onboard/Common/Common.styles";
import PLEXLoader from "../../../../components/PlexLoader/Loader";

import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import "../../Student/StudentDataCenter.css";

import withServices from "src/HOCs/withServices";

import { SOCKET as socket } from "../../../../common/constants";

import { tourSteps } from "./ViewStudentDataTour";
import Tour from "reactour";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { decodeSocketMessage } from "src/common/utils";

class ViewUserData extends React.Component<any, any> {
  public state = {
    assessmentinfo: {} as any,
    baseurl: currentBaseUrl(),
    breakdown: {} as any,
    currentassessmentid: 0,
    currentUser: "",
    currentprofile: {} as any,
    destination: "",
    navigate: false,
    toLogin: false,
    toProfile: false,
    sideNavCategory: "summary",
    sideNavOpen: false,
    currentUserID: null,
    perceptionsData: [],
    perceptionsDataLoaded: false,
    assessmentsData: [],
    assessmentsDataLoaded: false,
    assessment1ID: null,
    assessment2ID: null,
    groups: [],
    groupsLoaded: false,
    comparisonData: [],
    comparisonDataLoaded: false,
    currentFilterData: [],
    currentFilterLoaded: false,
    selectedGroup: null,
    loaded: false,
    downloadOpen: false,
    downloadAssessment: "",
    downloadComplete: false,
    sid: null,
    socketLoading: false,
    guidesRead: true,
  };
  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.onProfile = this.onProfile.bind(this);
    this.getAssessmentsViz = this.getAssessmentsViz.bind(this);
    this.getSummaryViz = this.getSummaryViz.bind(this);
    this.chooseCategory = this.chooseCategory.bind(this);
    this.handleAssessmentInfoLoaded =
      this.handleAssessmentInfoLoaded.bind(this);
    this.handleAssessmentResultsLoaded =
      this.handleAssessmentResultsLoaded.bind(this);
    this.toggleSideNav = this.toggleSideNav.bind(this);
    this.onClickOutside = this.onClickOutside.bind(this);
    this.handleAssessmentChosen = this.handleAssessmentChosen.bind(this);
    this.fetchComparisonsData = this.fetchComparisonsData.bind(this);
    this.getAllGenericResponses = this.getAllGenericResponses.bind(this);
    this.downloadAssessmentReport = this.downloadAssessmentReport.bind(this);
  }

  public onSocketConnect = () => {
    console.log("connected");
  };

  public onMessage(socketMessage) {
    const dataObj = decodeSocketMessage(socketMessage);
    this.setState({ socketLoading: false });
    const link = dataObj.message.data.link;
    window.open(link, "_blank");
  }

  public onSetup = (message) => {
    this.setState({ sid: message.id });
  };

  public componentWillUnmount() {
    console.log("removing sockets");

    socket.off("customNotif");
  }

  public async componentDidMount() {
    if (!socket.connected) {
      socket.connect();
    }
    socket.on("connect", this.onSocketConnect);

    socket.on("customEmit", (data) => this.onSetup(data));

    socket.on("customNotif", (data) => this.onMessage(data));

    if (!isUserLoggedIn()) {
      this.setState({ toLogin: true });
    } else {
      const {
        services: { adminAPI },
        match,
      } = this.props;
      const {
        params: { id: userID },
      } = match;
      const [perceptionRes, assessRes] = await Promise.all([
        adminAPI.getUserGenericPerceptionsList(userID),
        adminAPI.getUserAssessmentsList(userID),
      ]);

      const tourStatus = localStorage.getItem(
        `${this.props.services.currentUsername}ViewStudentDataTour`
      );
      let guidesRead = true;
      if (tourStatus === null) {
        guidesRead = false;
      }

      if (perceptionRes.ok) {
        const assessmentsData = assessRes.data.assessments;

        this.setState({
          perceptionsData: perceptionRes.data.perceptions,
          perceptionsDataLoaded: true,
          assessmentsData,
          assessmentsDataLoaded: true,
          guidesRead,
        });

        this.getAllGenericResponses(userID, assessmentsData[0].id);
      }
      // load breakdown
      getGeneralSmartTableData(
        "datacenter/school_student_assessments_breakdown?id=" +
          this.currentid(),
        (text) => this.handleAssessmentBreakdownLoaded(text)
      );
      this.setState({ username: currentUser(), currentUserID: userID });
    }

    socket.emit("customMsg", { evt: "init" });
  }

  public async getAllGenericResponses(userID, assessmentID) {
    const {
      services: { adminAPI },
    } = this.props;
    const performanceRes = await adminAPI.getAllGenericResponses(
      userID,
      assessmentID
    );
    if (performanceRes.ok) {
      this.setState({ assessmentinfo: performanceRes.data, loaded: true });
    }
  }

  public toggleSideNav() {
    const navstate = this.state.sideNavOpen;
    this.setState({ sideNavOpen: !navstate });
  }

  public onClickOutside() {
    this.setState({ sideNavOpen: false });
  }

  public closeTour = () => {
    localStorage.setItem(
      `${this.props.services.currentUsername}ViewStudentDataTour`,
      "true"
    );
    this.setState({ guidesRead: true });
  };

  public disableBody = (target) => {
    disableBodyScroll(target);
  };
  public enableBody = (target) => {
    enableBodyScroll(target);
  };

  public assignClass = (clicked, current) => {
    if (clicked === +current) {
      return "sf-button-active";
    } else {
      return "";
    }
  };
  public currentUserKey = () => {
    const { userType } = this.props;
    if (userType === "students") {
      return "name_students";
    } else {
      return "name_teachers";
    }
  };
  public handleAssessmentBreakdownLoaded(res) {
    if (res.code === 200) {
      const respobj = res.response as any;
      this.setState({
        breakdown: respobj.breakdown,
        currentassessmentid: respobj.breakdown.assessments[0].id,
        currentUser: respobj.breakdown.name,
        currentprofile: respobj.breakdown.profile,
      });
    } else if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  public currentid() {
    const key1 = "match";
    return this.props[key1].params.id;
  }
  public geneRateQnlevel = (response) => {
    const percent = response.Score / 100;
    const mn = Math.round(percent * 4);
    const rslt = Math.round(5 - mn);
    return Math.min(5, rslt);
  };

  public handleAssessmentInfoLoaded(res) {
    if (res.code === 200) {
      const respons = res.response as any;
      this.setState({ currentassessmentid: respons.id });
      getGeneralSmartTableData(
        "admin/assessments/" +
          this.state.currentassessmentid +
          "/school_user_completed_assessment/?id=" +
          this.currentid(),
        (text) => this.handleAssessmentResultsLoaded(text)
      );
    } else if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  public handleAssessmentResultsLoaded(res) {
    if (res.code === 200) {
      this.setState({ loaded: true, assessmentinfo: res.response });
    }

    if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  public onProfile(arg) {
    this.setState({ toProfile: true });
  }

  public onLogout(arg) {
    this.setState({ toLogin: true });
  }

  // content methods
  public chooseCategory(evtKey, event) {
    this.setState({ sideNavCategory: evtKey });
  }
  public closeDownloadCompleteModal = () => {
    this.setState({ downloadComplete: false });
  };

  public toggleDownloadModal = () => {
    const { downloadOpen } = this.state;
    this.setState({ downloadOpen: !downloadOpen });
  };

  public onSelectAssessmentReport = (e) => {
    this.setState({ downloadAssessment: e.target.value });
  };

  public async downloadAssessmentReport() {
    const { downloadAssessment } = this.state;
    if (!downloadAssessment) {
      toast.warn("You must pick a cohort");
      return;
    }

    this.setState({ socketLoading: true });
    const downloadRes =
      await this.props.services.institutionsAPI.generateStudentAssessmentReport(
        this.currentid(),
        downloadAssessment,
        this.state.sid
      );
    if (downloadRes.ok) {
      this.setState({ downloadOpen: false, downloadComplete: true });
    } else {
      toast.error("Ooops, the report could not be generated, try again.");
    }
  }

  public async fetchComparisonsData(e) {
    // fetch data with submitted vals
    e.preventDefault();
    const { assessment1ID, assessment2ID, currentUserID } = this.state;
    const {
      services: { adminAPI },
    } = this.props;
    if (assessment1ID !== "" && assessment2ID !== "") {
      const res = await adminAPI.getUserResponsesComparison(
        currentUserID,
        assessment1ID,
        assessment2ID
      );
      if (res.ok) {
        const assessment1 = "assessment_1_responses";
        // const assessment2 = 'assessment_2_responses';
        const groups = new Array();
        const ids = new Set();
        res.data.responses.map((responsePair) => {
          const item = {
            Group: responsePair[assessment1].Group,
            GroupId: responsePair[assessment1].GroupId,
          };
          groups.push(item);
          ids.add(responsePair[assessment1].GroupId);
        });
        const groupIDs = Array.from(ids);
        const groupNames = new Array();
        groupIDs.filter((group: any) => {
          const item = groups.find((grp: any) => grp.GroupId === group);
          groupNames.push(item);
        });

        this.setState({
          groups: groupNames,
          groupsLoaded: true,
          comparisonData: res.data.responses,
          comparisonDataLoaded: true,
        });
      } else if (res.status === 400) {
        toast.error(
          "Assessments Cannot Be Compared, Choose Assessments with the same number of questions!"
        );
      }
    }
  }

  public assessmentSelectionHandler = (assessment, event) => {
    // set assessment values to state for later use
    if (assessment === "assessment1") {
      this.setState({ assessment1ID: event.target.value });
    } else if (assessment === "assessment2") {
      this.setState({ assessment2ID: event.target.value });
    }
  };

  public renderDownloadCompleteModal = () => {
    return (
      <Modal
        visible={this.state.downloadComplete}
        effect="fadeInDown"
        height="200"
        width="400"
      >
        <div className="exit-modal-container">
          <p className="exit-warning">
            Here are your reports. They will also be e-mailed to the address of
            the registered account holder.
          </p>
          <i
            style={{ fontSize: "48px", marginBottom: "20px" }}
            className="fa fa-check"
          />
          <div className="exit-warning-buttons">
            <button
              className="blue-button"
              onClick={this.closeDownloadCompleteModal}
            >
              Thank You
            </button>
          </div>
        </div>
      </Modal>
    );
  };

  public renderDownloadReportModal = () => {
    const { breakdown } = this.state;

    if (Object.entries(breakdown).length) {
      return (
        <Modal
          visible={this.state.downloadOpen}
          effect="fadeInDown"
          width="400"
          height="300"
          onClickAway={this.toggleDownloadModal}
        >
          <div
            style={{
              backgroundColor: "#1a1a1a",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              color: "#fff",
              padding: "1.25em",
              fontStyle: "italic",
              height: "100%",
            }}
          >
            <h5 style={{ fontWeight: "bold", color: "#fff" }}>REPORTING</h5>
            <p>Pick an Assessment</p>
            <div className="show-picker">
              {/* <span>Choose an assessment to explore &nbsp; </span> */}
              <span>
                <select
                  className="custom-select sf-select"
                  onChange={this.onSelectAssessmentReport}
                  style={{ width: "320px" }}
                >
                  <option value=""> -- Pick an assessment -- </option>
                  {breakdown.assessments.map((assessment) => (
                    <option
                      key={`download-${assessment.id}`}
                      value={assessment.id}
                    >
                      {assessment.title}
                    </option>
                  ))}
                </select>
              </span>
            </div>
            <button
              onClick={this.downloadAssessmentReport}
              className="blue-button"
              style={{
                padding: "0.5em 1em",
                marginTop: "1.5em",
                width: "300px",
              }}
            >
              Download
            </button>
          </div>
        </Modal>
      );
    } else {
      console.log("Breakdown loadin ...");
      return "";
    }
  };

  public getCategoryViz() {
    if (this.state.sideNavCategory === "summary") {
      return this.getSummaryViz();
    } else if (this.state.sideNavCategory === "my-assessments") {
      return this.getAssessmentsViz();
    } else if (this.state.sideNavCategory === "perceptions") {
      return this.getPerceptionsPlot();
    } else if (this.state.sideNavCategory === "responses") {
      return this.getResponseComparisonViz();
    } else {
      return <div>No data to show yet</div>;
    }
  }
  public getSummaryViz() {
    return (
      <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
        <div className="student-data-summary">
          <div className="student-center-header">
            <h1 className="dashboard-name">
              PROGRESS &amp; ATTAINMENT DASHBOARD
            </h1>
          </div>
          <div className="student-center-row">
            <div className="student-summary summary-left">
              <h2 className="tile-name" style={{ marginTop: "-0.625em" }}>
                SUMMARY
              </h2>
              <div className="summary-details">
                <div className="student-details">
                  <h4 className="detail-name">Name</h4>
                  <p className="detail-value">{this.state.currentUser}</p>
                  {/* <h4 className="detail-name">Age</h4>
                  <p className="detail-value">
                    {getUserAge(this.state.currentprofile.dob)} Years Old
                  </p>{" "} */}
                  {/* replace with actual data */}
                  <h4 className="detail-name">Institution</h4>
                  <p className="detail-value">
                    {this.state.currentprofile.school}
                  </p>{" "}
                  {/* replace with actual data */}
                </div>
                <div className="student-assessments">
                  <h4 className="detail-name">Complete Assessments</h4>

                  <div id="value-border1">
                    <p style={{ margin: "0" }} className="complete-assessments">
                      {this.state.breakdown.completed}
                    </p>
                  </div>
                  <h4 className="detail-name">Incomplete Assessments</h4>

                  <div id="value-border2">
                    <p
                      style={{ margin: "0" }}
                      className="incomplete-assessments"
                    >
                      {this.state.breakdown.incomplete}
                    </p>
                  </div>
                </div>
              </div>
            </div>{" "}
            {/* end summary left */}
            <div className="student-trait summary-right step-1">
              <h2 className="trait-tile-name">
                {this.props.userType === "teachers"
                  ? "YOUR PERFORMANCE LEARNING TEACHING PROFILE"
                  : "YOUR PERFORMANCE LEARNING SCORE AND PROFILE"}{" "}
              </h2>
              <TraitTile
                results={this.state.assessmentinfo.results}
                vimeoModel="students"
              />
            </div>
          </div>{" "}
          {/* end row1 */}
          <div className="student-center-row">
            <div className="student-perceptions step-2">
              {this.state.loaded ? (
                <PerceptionsTile
                  results={this.state.assessmentinfo.results.Perceptions}
                  services={this.props.services}
                  designation={this.props.userType}
                  // openModal = {this.handleOpenModal}
                />
              ) : (
                "loading"
              )}
            </div>
            <div className="student-responses step-3">
              <ResponsesTile responseData={this.state.assessmentinfo.results} />
            </div>
          </div>{" "}
          {/* end row 2 */}
        </div>
      </CSSTransition>
    );
  }

  public handleAssessmentChosen(event) {
    this.getAllGenericResponses(this.currentid(), event.target.value);
  }

  public questionGroupClickHandler = (event) => {
    const { comparisonData, comparisonDataLoaded, groups } = this.state;
    const groupid = event.target.value;
    const currentFilterData = new Array();
    const key1 = "assessment_1_responses";
    if (comparisonDataLoaded) {
      comparisonData.map((responsePair: any) => {
        if (responsePair[key1].GroupId === +groupid) {
          currentFilterData.push(responsePair);
        }
      });

      this.setState({
        currentFilterData,
        currentFilterLoaded: true,
        selectedGroup: groupid,
      });
    }
  };

  public getAssessmentsViz() {
    return (
      <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
        <div className="student-assessments-data">
          <div className="student-center-header">
            <h1 className="dashboard-name">
              {this.state.currentUser}'S ASSESSMENTS RESULTS
            </h1>
            <p className="data-guide">
              Select an<span> assessment</span> to
              <span style={{ textTransform: "capitalize" }}>
                {this.state.currentUser + " 's"}
              </span>
              &nbsp;result
            </p>
            <h2 className="selected-assessment">
              Assessment{" "}
              <span> {this.state.assessmentinfo.assessment_info.Title}</span>
            </h2>
          </div>
          <div className="student-center-row">
            <div className="student-center-left">
              <select
                onChange={this.handleAssessmentChosen}
                style={{ width: "500px" }}
                name="student-assessments"
                id="student-assessments"
                className="custom-select assessments-select"
              >
                {/* <option value="23">--</option> */}
                {this.state.breakdown.assessments.map((d) => (
                  <option
                    key={d.id}
                    value={d.id}
                    selected={d.id === this.state.currentassessmentid}
                  >
                    {" "}
                    {d.title}
                  </option>
                ))}
              </select>

              <button
                style={{ display: "none" }}
                className="save-report blue-button"
              >
                SAVE REPORT
              </button>
            </div>
            <div className="student-trait summary-right">
              <h2 className="trait-tile-name">
                {this.props.userType === "teachers"
                  ? "YOUR PERFORMANCE LEARNING TEACHING PROFILE"
                  : "YOUR PERFORMANCE LEARNING SCORE AND PROFILE"}
              </h2>
              <TraitTile
                results={this.state.assessmentinfo.results}
                vimeoModel="students"
              />
            </div>
          </div>
          <div className="student-center-row">
            <div className="student-perceptions">
              <PerceptionsTile
                results={this.state.assessmentinfo.results.Perceptions}
                services={this.props.services}
                designation={this.props.userType}
                // openModal = {this.handleOpenModal}
              />
            </div>
            <div className="student-responses">
              <ResponsesTile responseData={this.state.assessmentinfo.results} />
            </div>
          </div>
        </div>
      </CSSTransition>
    );
  }

  public getResponseComparisonViz = () => {
    const { assessmentsDataLoaded, assessmentsData } = this.state;
    return (
      <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
        <div className="student-assessments-data">
          <div className="school-center-header">
            <h1 className="dashboard-name">
              <span>{this.state.currentUser}'S</span> RESPONSE COMPARISON
            </h1>
            {assessmentsDataLoaded && assessmentsData.length > 1 ? (
              <p className="data-guide">
                Choose two assessments to compare{" "}
                <span style={{ textTransform: "capitalize" }}>
                  {this.state.currentUser + " "}
                </span>{" "}
                responses
              </p>
            ) : (
              ""
            )}

            {/* <h2 className="selected-assessment">Assessment <span> {this.state.assessmentinfo.assessment_info.Title}</span></h2> */}
            {this.renderComparisonAssessmentsPicker()}
            {this.renderQuestionGroupButtons()}
            <div className="response-charts-container">
              {this.renderResponsesComparisons()}
            </div>
          </div>
        </div>
      </CSSTransition>
    );
  };

  public getPerceptionsPlot = () => {
    const { perceptionsData, perceptionsDataLoaded } = this.state;
    if (perceptionsDataLoaded && this.state.breakdown.completed > 0) {
      return (
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="student-data-summary">
            <div className="student-center-header">
              <h1 className="dashboard-name">
                YOUR <span>PERCEPTIONS</span>
              </h1>
            </div>
            <div className="student-perceptions-plot">
              <div className="perceptions-grid">
                {perceptionsData.map((perception: any) => {
                  return (
                    <div
                      key={perception.name}
                      className="perception-graph-holder"
                    >
                      <h2 className="perception-plot-title">
                        {perception.definition_data.data[this.currentUserKey()]}
                      </h2>
                      {this.renderPerceptionGraph(perception.assessmemts)}
                    </div>
                  );
                })}
              </div>
            </div>
            {/* end row1 */}
          </div>
        </CSSTransition>
      );
    } else {
      return (
        <div className="dc-no-content">
          <h1 className="dashboard-name">
            <span>Hi {currentUser()}</span>, this section is available once you
            complete more assessments
          </h1>
        </div>
      );
    }
  };

  public renderComparisonAssessmentsPicker = () => {
    const { assessmentsData, assessmentsDataLoaded } = this.state;
    if (assessmentsDataLoaded && assessmentsData.length > 1) {
      return (
        <div className="response-comparisons-wrapper">
          <form
            className="comparisons-form"
            onSubmit={this.fetchComparisonsData}
          >
            <select
              required={true}
              onChange={this.assessmentSelectionHandler.bind(
                this,
                "assessment1"
              )}
              name="assessment1"
              id="assessment1"
              className="comparison-assessment-select custom-select"
            >
              <option value="">--</option>
              {assessmentsData.map((assessment: any) => (
                <option value={assessment.id}>{assessment.Title}</option>
              ))}
            </select>
            <span>VS.</span>
            <select
              required={true}
              onChange={this.assessmentSelectionHandler.bind(
                this,
                "assessment2"
              )}
              name="assessment2"
              id="assessment1"
              className="comparison-assessment-select custom-select"
            >
              <option value="">--</option>
              {assessmentsData.map((assessment: any) => (
                <option value={assessment.id}>{assessment.Title}</option>
              ))}
            </select>
            <button type="submit" className="blue-button compare-responses">
              Compare
            </button>
          </form>
        </div>
      );
    } else {
      return (
        <h3
          className="dashboard-name"
          style={{
            color: "var(--text-light)",
            textAlign: "center",
            textTransform: "uppercase",
            fontStyle: "italic",
          }}
        >
          Not enough assessments for a comparison
        </h3>
      );
    }
  };

  public renderResponsesComparisons = () => {
    const {
      currentFilterData,
      currentFilterLoaded,
      comparisonDataLoaded,
      groups,
    } = this.state;
    const key1 = "assessment_1_responses";
    const key2 = "assessment_2_responses";

    console.log({ currentFilterData });
    if (currentFilterLoaded) {
      // coming
      return currentFilterData.map((responsePair: any) => {
        const data1 = responsePair[key1];
        const data2 = responsePair[key2];
        // console.log("CurrentFilterDa: " + data1.Score);

        return (
          <div key={responsePair[key1].id}>
            <p className="responsepair-heading">{`${data1.Group} Q: `}</p>
            <div className="responsepair-wrapper">
              <div className="single-response-wrapper">
                <SingleResponseChart
                  alertLevel={this.geneRateQnlevel(data1)}
                  question={data1.Question}
                  answer={data1.AnswerValue}
                />
              </div>
              <div className="single-response-wrapper">
                <SingleResponseChart
                  alertLevel={this.geneRateQnlevel(data2)}
                  question={data2.Question}
                  answer={data2.AnswerValue}
                />
              </div>
            </div>
          </div>
        );
      });
    } else {
      return <div />;
    }
  };

  public renderQuestionGroupButtons = () => {
    const { groups, groupsLoaded, selectedGroup } = this.state;

    if (groupsLoaded) {
      // coming
      return (
        <div className="comparisons-buttons-wrapper">
          {groups.map((group: any) => (
            <button
              key={group.Group}
              className={`sf-button ${this.assignClass(
                group.GroupId,
                selectedGroup
              )}`}
              value={group.GroupId}
              onClick={this.questionGroupClickHandler}
              style={{
                height: "10em !important",
              }}
            >
              {group.Group}
            </button>
          ))}
        </div>
      );
    } else {
      return <div />;
    }
  };

  public renderPerceptionGraph = (assessments) => {
    const barData = assessments.map((assessment) => {
      return {
        assessment: assessment.assessmentName,
        perceptionLevel: Math.round(assessment.value * 12.5),
      };
    });

    const keys = ["perceptionLevel"];
    return <BarGraph data={barData} keys={keys} xKey="assessment" />;
  };

  public render() {
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }
    if (this.state.toProfile) {
      return <Redirect to={this.state.baseurl + "profile"} />;
    }

    return (
      <div className="data-center">
        <ToastContainer />
        <NavBar logoutParent={this.onLogout} profileParent={this.onProfile} />
        <Tour
          steps={tourSteps}
          isOpen={!this.state.guidesRead}
          onRequestClose={this.closeTour}
          onAfterOpen={this.disableBody}
          onBeforeClose={this.enableBody}
          accentColor="#ff0033"
        />
        {this.renderDownloadReportModal()}
        {this.renderDownloadCompleteModal()}
        <ClickOutside onClickOutside={this.onClickOutside}>
          <Sidenav
            onSelect={this.chooseCategory}
            className="datacenter-nav"
            expanded={this.state.sideNavOpen}
            onToggle={this.toggleSideNav}
          >
            <Sidenav.Toggle />
            <Sidenav.Nav defaultSelected="summary">
              <NavItem eventKey="summary">
                <NavIcon>
                  {/* icon goes here */}
                  {/* <img style={{width:"30px", paddingTop: "6px"}} src={icon1}/> */}
                  <span
                    className="navicon"
                    style={
                      this.state.sideNavCategory === "summary"
                        ? { color: "#ff0033" }
                        : { color: "#fff" }
                    }
                  >
                    S
                  </span>
                </NavIcon>
                <NavText>Summary</NavText>
              </NavItem>
              <NavItem eventKey="my-assessments">
                <NavIcon>
                  {/* icon goes here */}
                  {/* <img style={{width:"30px", paddingTop: "6px"}} src={icon2}/> */}
                  <span
                    className="navicon"
                    style={
                      this.state.sideNavCategory === "my-assessments"
                        ? { color: "#ff0033" }
                        : { color: "#fff" }
                    }
                  >
                    A
                  </span>
                </NavIcon>
                <NavText>
                  {this.state.currentUser}'s Assessments{" "}
                  {/*Replace with student name */}
                </NavText>
              </NavItem>
              <NavItem eventKey="perceptions">
                <NavIcon>
                  {/* icon goes here */}
                  {/* <img style={{width:"30px", paddingTop: "6px"}} src={icon2}/> */}
                  <span
                    className="navicon"
                    style={
                      this.state.sideNavCategory === "perceptions"
                        ? { color: "#ff0033" }
                        : { color: "#fff" }
                    }
                  >
                    P
                  </span>
                </NavIcon>
                <NavText>
                  {this.state.currentUser}'s Perceptions{" "}
                  {/*Replace with student name */}
                </NavText>
              </NavItem>
              <NavItem eventKey="responses">
                <NavIcon>
                  {/* icon goes here */}
                  {/* <img style={{width:"30px", paddingTop: "6px"}} src={icon2}/> */}
                  <span
                    className="navicon"
                    style={
                      this.state.sideNavCategory === "responses"
                        ? { color: "#ff0033" }
                        : { color: "#fff" }
                    }
                  >
                    R
                  </span>
                </NavIcon>
                <NavText>
                  {this.state.currentUser}'s Perceptions{" "}
                  {/*Replace with student name */}
                </NavText>
              </NavItem>
            </Sidenav.Nav>
          </Sidenav>
        </ClickOutside>
        <div className="data-container">
          {/* <ModalVideo channel="youtube" isOpen={this.state.isVidModalOpen} onClose={this.closeVideoModal} videoId="{this.state.videoLink}" /> */}

          {this.getCategoryViz()}
          <FabButton
            className="step-4"
            bgColor="#1a1a1a"
            right="8px"
            bottom="80%"
            onClick={this.toggleDownloadModal}
          >
            <p className="fab-text">Download Report</p>
            <i
              className="fa fa-download"
              style={{ fontSize: "30px", color: "#ff0033" }}
            />
          </FabButton>
          <FabButton
            className="step-4"
            bgColor="#1a1a1a"
            right="8px"
            bottom="80%"
            onClick={this.toggleDownloadModal}
          >
            <p className="fab-text">Download Report</p>
            <i
              className="fa fa-download"
              style={{ fontSize: "30px", color: "#ff0033" }}
            />
          </FabButton>
          {/* <CustomScatterGraph/> */}
          {this.state.socketLoading ? (
            // <Loaderr>
            //   <PLEXLoader width={150} height={100} loaderId={4} />{" "}
            // </Loaderr>
            <SimpleLoader text="PL is working..." />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
export default withServices(ViewUserData);



// WEBPACK FOOTER //
// ./src/pages/DataCenter/School/ViewStudentData/viewStudentData.Component.tsx